// API接口配置
const BASE_URL = '/api'

// 通用请求方法
const request = async (url, method = 'GET', data = {}) => {
  const token = localStorage.getItem('token')
  const headers = {
    'Content-Type': 'application/json'
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const options = {
    method,
    headers
  }

  if (method === 'POST' || method === 'PUT') {
    options.body = JSON.stringify(data)
  }

  try {
    const response = await fetch(`${BASE_URL}${url}`, options)
    const result = await response.json()

    if (result.code === 200) {
      return result
    } else {
      throw new Error(result.message || '请求失败')
    }
  } catch (error) {
    console.error('API请求错误:', error)
    throw error
  }
}

// 仓房相关API
export const warehouseApi = {
  getWarehouses: (keyword = '') => {
    const query = keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''
    return request(`/warehouse/list${query}`)
  },
  getWarehouseDetail: (id) => request(`/warehouse/detail/${id}`),
  addWarehouse: (data) => request('/warehouse/add', 'POST', data),
  updateWarehouse: (id, data) => request(`/warehouse/update/${id}`, 'PUT', data),
  deleteWarehouse: (id) => request(`/warehouse/delete/${id}`, 'DELETE')
}

// 发粮口相关API
export const grainOutletApi = {
  getOutletsByWarehouse: (warehouseId) => request(`/grain-outlet/list/${warehouseId}`),
  getOutletsWithDevices: (warehouseId) => request(`/grain-outlet/list-with-devices/${warehouseId}`),
  getOutletDetail: (id) => request(`/grain-outlet/detail/${id}`),
  addOutlet: (data) => request('/grain-outlet/add', 'POST', data),
  updateOutlet: (id, data) => request(`/grain-outlet/update/${id}`, 'PUT', data),
  deleteOutlet: (id) => request(`/grain-outlet/delete/${id}`, 'DELETE')
}

// 发粮口设备配置相关API
export const grainOutletDeviceApi = {
  getOutletDevices: (outletId) => request(`/grain-outlet-device/list/${outletId}`),
  saveConfig: (data) => request('/grain-outlet-device/save-config', 'POST', data),
  bindDevice: (data) => request('/grain-outlet-device/bind', 'POST', data),
  unbindDevice: (id) => request(`/grain-outlet-device/unbind/${id}`, 'DELETE'),
  updateConfig: (id, data) => request(`/grain-outlet-device/update/${id}`, 'PUT', data),
  getWarehouseCameras: (warehouseId) => request(`/grain-outlet-device/monitor/warehouse/${warehouseId}`)
}

// 值仓记录 API
export const warehouseDutyApi = {
  list: (date, storekeeperId) => {
    const params = []
    if (date) params.push(`date=${encodeURIComponent(date)}`)
    if (storekeeperId) params.push(`storekeeperId=${storekeeperId}`)
    const query = params.length ? `?${params.join('&')}` : ''
    return request(`/warehouse-duty/list${query}`)
  },
  detail: (id) => request(`/warehouse-duty/detail/${id}`)
}

// 侧壁放粮 API
export const sideWallApi = {
  previewParams: (warehouseDutyId, grainOutletId) =>
    request(`/side-wall/dispensing/preview-params?warehouseDutyId=${warehouseDutyId}&grainOutletId=${grainOutletId}`),
  startDispensing: (data) => request('/side-wall/dispensing/start', 'POST', data),
  stopDispensing: (sessionId) => request('/side-wall/dispensing/stop', 'POST', { sessionId }),
  getStatus: (params) => {
    const query = Object.keys(params)
      .filter(k => params[k] != null)
      .map(k => `${k}=${params[k]}`)
      .join('&')
    return request(`/side-wall/dispensing/status?${query}`)
  },
  listPhotos: (sessionId) => request(`/side-wall/dispensing/${sessionId}/photos`),
  startStream: (outletId) => request(`/side-wall/camera/${outletId}/stream/start`, 'POST', {}),
  stopStream: (outletId) => request(`/side-wall/camera/${outletId}/stream/stop`, 'POST', {}),
  snapshot: async (outletId, formData) => {
    const token = localStorage.getItem('token')
    const headers = {}
    if (token) headers.Authorization = `Bearer ${token}`
    const response = await fetch(`/api/side-wall/camera/${outletId}/snapshot`, {
      method: 'POST',
      headers,
      body: formData
    })
    const result = await response.json()
    if (result.code === 200) return result
    throw new Error(result.message || '拍照失败')
  }
}
